'use client';

import { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Hero2 from '../components/Hero2';
import Features from '../components/Features';
import Testimonials from '../components/Testimonials';
import Table from '../components/Table';
import Cta from '../components/Cta';
import Faq from '../components/Faq';
import Footer from '../components/Footer';
import Tools from '../components/Tools';
import SEO from '../components/SEO';
import { TRACKING_API_URL } from '../config';

export default function IaParaAdvogados() {
  useEffect(() => {
    // Track PageView event
    fetch(TRACKING_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        event_name: 'PageView',
        page: 'ia-para-advogados'
      }),
    })
      .then(() => console.log('PageView event tracked'))
      .catch((error) => console.error('Error tracking PageView event:', error));
  }, []);

  return (
    <div className="bg-[#081428] text-white min-h-screen">
      <SEO
        title="IA para Advogados"
        description="Descubra como a inteligência artificial está transformando a prática jurídica. Conheça as melhores ferramentas de IA para advogados."
        keywords="IA para advogados, inteligência artificial jurídica, automação jurídica, legaltech Brasil"
        url="/ia-para-advogados"
      />
      <Navbar />
      <Hero2 />
      <Tools />
      <Features />
      <Table />
      <Testimonials />
      <Cta />
      <Faq />
      <Footer />
    </div>
  );
} 